export const hasDynamicHeight = element => {
  if (!element) return false;

  if (element.displayType === 'hauteur dynamique') {
    return true;
  }

  if (element.type === 'link' && element.displayType === 'complet dynamique') {
    return true;
  }

  return false;
};
